import React from 'react';
import PropTypes from 'prop-types';
import { Box, Card, CardContent, Typography } from '@mui/material';
import { motion } from 'framer-motion';
import {
  WorkspacePremium,
  PersonOutline,
  Visibility,
  FactCheck,
  HomeRepairService,
  Devices,
  Gavel,
  TrendingUp,
  Payments,
} from '@mui/icons-material';
import { fadeInUp, cardHover } from '../../utils/animations';

const iconMap = {
  WorkspacePremium: WorkspacePremium,
  PersonOutline: PersonOutline,
  Visibility: Visibility,
  FactCheck: FactCheck,
  HomeRepairService: HomeRepairService,
  Devices: Devices,
  Gavel: Gavel,
  TrendingUp: TrendingUp,
  Payments: Payments,
};

const FeatureCard = ({ title, description, icon, index = 0 }) => {
  const IconComponent = iconMap[icon] || WorkspacePremium;

  return (
    <Box
      component={motion.div}
      variants={fadeInUp}
      custom={index}
      initial="rest"
      whileHover="hover"
      animate="rest"
    >
      <Card
        component={motion.div}
        variants={cardHover}
        sx={{
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          cursor: 'pointer',
          border: '1px solid',
          borderColor: 'grey.100',
          backgroundColor: 'background.paper',
          '&:hover': {
            borderColor: 'secondary.light',
          },
        }}
      >
        <CardContent sx={{ p: 3, flexGrow: 1 }}>
          <Box
            sx={{
              width: 56,
              height: 56,
              borderRadius: 2,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              background: 'linear-gradient(135deg, rgba(201, 169, 97, 0.1) 0%, rgba(30, 58, 95, 0.05) 100%)',
              mb: 2.5,
            }}
          >
            <IconComponent
              sx={{
                fontSize: 28,
                color: 'secondary.main',
              }}
            />
          </Box>
          <Typography
            variant="h5"
            component="h3"
            gutterBottom
            sx={{
              fontWeight: 600,
              color: 'text.primary',
              mb: 1.5,
            }}
          >
            {title}
          </Typography>
          <Typography
            variant="body2"
            sx={{
              color: 'text.secondary',
              lineHeight: 1.7,
            }}
          >
            {description}
          </Typography>
        </CardContent>
      </Card>
    </Box>
  );
};

FeatureCard.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  icon: PropTypes.string,
  index: PropTypes.number,
};

export default FeatureCard;
